import { render } from "./MonthlyManagementFeeReport.vue?vue&type=template&id=0c145908"
import script from "./MonthlyManagementFeeReport.vue?vue&type=script&lang=js"
export * from "./MonthlyManagementFeeReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__